/**
 * ログインの失敗を画面の文言にする純関数。Better-Auth のコードが付くものは訳し、付かないもの
 * （サーバー側のフックが投げる日本語のメッセージ）はそのまま出す。
 */

type AuthError = { code?: string; message?: string };

const MESSAGE_KEY_BY_CODE: Record<string, string> = {
  INVALID_EMAIL_OR_PASSWORD: "login.errors.invalidCredentials",
  INVALID_PASSWORD: "login.errors.invalidCredentials",
  USER_NOT_FOUND: "login.errors.invalidCredentials",
  EMAIL_NOT_VERIFIED: "login.errors.emailNotVerified",
  INVALID_EMAIL: "login.validation.email",
};

export function loginErrorMessage(error: AuthError, t: (key: string) => string): string {
  const key = error.code ? MESSAGE_KEY_BY_CODE[error.code] : undefined;
  if (key) return t(key);
  return error.message ?? t("login.error");
}

/**
 * 「メールアドレスの確認が完了していません」か。サーバーは agent だけにこの制限をかけており、
 * Better-Auth の標準コードではなく FORBIDDEN + 日本語のメッセージで返ってくるので、
 * コードと文面の両方を見る。
 */
export function isUnverifiedEmailError(error: AuthError): boolean {
  if (error.code === "EMAIL_NOT_VERIFIED") return true;
  return (error.message ?? "").includes("メールアドレスの確認");
}
